
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.77 1.408C14.162.47 12.405 0 10.5 0 8.595 0 6.838.47 5.23 1.408A10.455 10.455 0 001.407 5.23C.47 6.84 0 8.595 0 10.5c0 2.124.579 4.051 1.736 5.783 1.158 1.732 2.675 3.012 4.553 3.842-.037-.976.023-1.782.178-2.42L7.82 11.99c-.228-.446-.342-1.002-.342-1.668 0-.774.196-1.422.588-1.941.392-.52.87-.78 1.436-.78.455 0 .806.15 1.053.452.246.3.369.679.369 1.134 0 .283-.053.627-.157 1.033-.105.405-.242.875-.41 1.408-.169.533-.29.959-.363 1.278-.128.556-.023 1.032.315 1.429.337.396.784.594 1.34.594.975 0 1.775-.542 2.4-1.626.623-1.085.936-2.402.936-3.952 0-1.194-.385-2.165-1.156-2.912-.77-.747-1.843-1.12-3.22-1.12-1.54 0-2.786.494-3.739 1.482-.952.99-1.428 2.172-1.428 3.548 0 .82.232 1.509.697 2.065.155.182.205.378.15.587a7.569 7.569 0 00-.109.41c-.055.219-.091.36-.11.424-.072.292-.246.383-.52.274-.701-.292-1.234-.798-1.599-1.518-.364-.72-.546-1.554-.546-2.502 0-.61.097-1.221.293-1.832.196-.61.501-1.2.916-1.77a7.2 7.2 0 011.49-1.511c.58-.438 1.284-.788 2.113-1.053a8.785 8.785 0 012.68-.396c1.294 0 2.456.287 3.486.86 1.03.575 1.816 1.318 2.359 2.23.542.911.813 1.886.813 2.925 0 1.368-.237 2.598-.71 3.692-.475 1.094-1.145 1.953-2.01 2.577-.867.624-1.851.936-2.954.936-.556 0-1.075-.13-1.559-.39-.483-.259-.816-.567-.998-.922-.41 1.613-.656 2.575-.738 2.885-.173.647-.529 1.394-1.067 2.242.976.291 1.97.437 2.981.437 1.905 0 3.662-.47 5.27-1.408a10.455 10.455 0 003.822-3.822C20.53 14.162 21 12.405 21 10.5c0-1.905-.47-3.662-1.408-5.27a10.46 10.46 0 00-3.822-3.82z"}})])
          )
        }
      }
    